import { Panel } from '@/components/Panel';

/** Page propre à une société alors que l'utilisateur n'est rattaché à aucune */
export function NoCompanySelected() {
  return (
    <Panel className="p-6 text-sm text-slate-500">
      Aucune société sélectionnée : vous n'êtes rattaché à aucune société.
    </Panel>
  );
}
